import { render, staticRenderFns } from "./InviteGuestPopup.vue?vue&type=template&id=2b89105e&scoped=true"
import script from "./InviteGuestPopup.vue?vue&type=script&lang=js"
export * from "./InviteGuestPopup.vue?vue&type=script&lang=js"
import style0 from "./InviteGuestPopup.vue?vue&type=style&index=0&id=2b89105e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b89105e",
  null
  
)

export default component.exports